"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var HighlightOff = function HighlightOff(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.104 2.0791L2.07861 2.10547L21.8735 21.9004L20.4751 23.2998L16.4985 19.3232C16.3327 19.5142 16.1349 19.6711 15.9009 19.7881C15.6177 19.9295 15.3169 20 15.0005 20H2.00049L8.00049 12L4.47607 7.30078L0.675293 3.5L2.1001 2.0752L2.104 2.0791ZM6.00049 18H15.0005L15.0747 17.8994L9.93213 12.7568L6.00049 18Z",
    fill: "#currentColor"
  }), (0, _preact.h)("path", {
    d: "M15.0005 4C15.317 4 15.6176 4.07132 15.9009 4.21289C16.1841 4.3545 16.4178 4.54996 16.6011 4.7998L22.0005 12L18.9243 16.1006L17.4956 14.6719L19.5005 12L15.0005 6H8.82373L6.82373 4H15.0005Z",
    fill: "#currentColor"
  }));
};

var _default = HighlightOff;
exports.default = _default;